import React from 'react';
import HeroSection from '../../components/home/HeroSection';
import AboutSection from '../../components/home/AboutSection';
import ServicesSection from '../../components/home/ServicesSection';
import DownloadAppSection from '../../components/home/DownloadAppSection';
import Partners from '../../components/home/Partners';
import ProcessSection from '../../components/home/ProcessSection';
import WhyChooseUsSection from '../../components/home/WhyChooseUsSection';
import StatsSection from '../../components/home/StatsSection';
import TestimonialsSection from '../../components/home/TestimonialsSection';
import CtaSection from '../../components/home/CtaSection';
import MetaTags from 'react-meta-tags';

const Home = () => {
  return (
    <React.Fragment>
      <MetaTags>
        <title>Home | Subul Contracting</title>
      </MetaTags>

      {/* 1. Hero / First impression */}
      <HeroSection />

      {/* 2. Quick credibility */}
      <section className="py-5">
        <Partners />
      </section>
      
      {/* 3. Introduction */}
      <section className="py-5 bg-light">
        <AboutSection />
      </section>
      
      {/* 4. What we offer */}
      <section className="py-5">
        <ServicesSection />
      </section>

      {/* 5. How we work */}
      <section className="py-5 bg-light">
        <ProcessSection />
      </section>

      {/* 6. Why choose us */}
      <section className="py-5">
        <WhyChooseUsSection />
      </section>

      {/* 7. Trust builders: Numbers & Testimonials */}
      <section className="py-5 bg-light">
        <StatsSection />
      </section>

      <section className="py-5">
        <TestimonialsSection />
      </section>

      {/* 8. Closing CTA */}
      <section className="py-5 bg-light">
        <CtaSection />
      </section>
      
      {/* Optional: Keep app download at the bottom */}
      {/* <section className="py-5">
        <DownloadAppSection />
      </section> */}

    </React.Fragment>
  );
};

export default Home;
